import { Component } from '@angular/core';
import { inject } from '@angular/core';
import { OrderProcessingService } from 'app/server/server.module';
import { OrderlinePanelComponent } from 'app/shared/orderline-panel/orderline-panel.component';
import { takeUntil } from 'rxjs';
import { TreeNodeAggregates, TreeNodeDeclaration } from '@equipmyschool/emsadminweb-models';

@Component({
  selector: 'app-web-orders',
  templateUrl: '../../shared/orderline-panel/orderline-panel.component.html',
  styleUrls: ['../../shared/orderline-panel/orderline-panel.component.scss']
})
export class WebOrdersComponent extends OrderlinePanelComponent {
  private readonly orderService = inject(OrderProcessingService);

  constructor() {
    super();
    this.title = "Web Orders";
    this.nodes = [
      {
        name: "All Customers",
        id: "",
        aggregates: {
          group: [
            { id: "Customer", label: "Customer" },
            { id: "AccountNo", label: "AccountNo" },
            { id: "AdminName", label: "CCS" },
            { id: "DeputyName", label: "Deputy" }
          ],
          count: true,
          sum: [
            { id: "QuotedLineValue", label: "Value" }
          ]
        },
        display: ["AccountNo", "LineCount", "Value", "CCS", "Deputy"],
        sort: ["AccountNo"],
        selectionColumn: "Customer"
      },
      {
        name: "AccountNo",
        id: "Customer",
        aggregates: {
          group: [
            { id: "BudgetID", label: "BudgetID" },
            { id: "BudgetName", label: "BudgetName" }
          ]
        } as TreeNodeAggregates,
        display: ["BudgetName"],
        sort: ["BudgetName"],
        selectionColumn: "BudgetID"
      },
      {
        name: "BudgetName",
        id: "BudgetID",
        aggregates: {
          group: [
            { id: "SalesOrder", label: "SalesOrder" },
            { id: "SOReference", label: "SOReference" },
            { id: "Owner", label: "Owner" },
            { id: "CurrentStatus", label: "CurrentStatus" }
          ],
          count: true,
          sum: [
            { id: "BudgetAmount", label: "BudgetAmount" },
            { id: "Spent", label: "Spent" }
          ]
        },
        display: ["SOReference", "LineCount", "BudgetAmount", "Spent", "Owner", "CurrentStatus"],
        sort: ["SOReference"],
        selectionColumn: "SalesOrder"
      },
      {
        name: "SOReference",
        id: "SalesOrder",
        display: [
          "Notes", "Priority",
          "POLine", "Reference", "Description",
          "Quantity", "SupplierText",
          "StatusDescription", "ProductStatus", "FinanceStatusDesc",
          "SupplierName", 
          "EstimatedUnitPrice", "Added",
          "QuotedUnitPrice", "QuotedLineCost", "QuotedLineValue",
          "UnitPrice", "LineCost", "LineValue", "InvoiceLineValue", "CustomerDiscount",
          "ToBeInvoiced", "Priced", "Ordered", "Received", "NotAvailable", "Incorrect", "Dispatched",
          "RequiresServicing", "Url", "UnitType", "UnitAmount"
        ],
        sort: ["POLine"],
        selectionColumn: "LineID"
      } as TreeNodeDeclaration
    ];
  }

  refreshData(): void {
    if (this.selectedAdmin !== null) {
      this.orderService.getWebOrders(this.selectedAdmin).pipe(takeUntil(this.destroy$)).subscribe(res => this.datasource = res || []);
    }
  }
}
